<template>
	<section class="dashboard-highlight-column">
		<DashboardHighlightCard
			v-for="(card, index) in dashboardHighlightCards"
			:iconWeight="card.iconWeight"
			:icon="card.icon"
			:title="card.title"
			:description="card.description"
			:backgroundImage="card.backgroundImage"
			:key="index"
			:route="card.route"
		/>
		<FallBack v-if="isLoading" class="spinner-container">
			<LoadingIcon />
		</FallBack>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DashboardHighlightCard from './DashboardHighlightCard.vue';
import FallBack from '@/components/global/FallBack.vue';
import LoadingIcon from '@/components/global/LoadingIcon.vue';

export default {
	name: 'DashboardHighlightColumn',
	components: {
		DashboardHighlightCard,
		FallBack,
		LoadingIcon,
	},
	methods: {
		...mapActions(['getDashboardFeatureBanners']),
	},
	computed: mapState({
		dashboardHighlightCards: (state) => state.banners.dashboard.highlightCards,
		isLoading: (state) => state.banners.dashboard.loadingStatus,
		error: (state) => state.banners.dashboard.error,
	}),
	async created() {
		await this.getDashboardFeatureBanners();
	},
	watch: {
		error: function (val) {
			if (val) {
				console.log(val);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.dashboard-highlight-column {
	@include rem(max-width, 250px);
	@include rem('grid-gap', 15px);
	@include rem('margin', 15px 30px 15px 0);
	display: grid;
	grid-column-start: 2;
	grid-row-start: 1;
	justify-content: center;

	@include mobile {
		@include rem('margin', 15px 0);
		grid-column-start: unset;
		grid-row-start: unset;
		grid-template-columns: 100%;
		max-width: unset;
		justify-self: center;
	}
}
.spinner-container {
	@include rem(width, 250px);
	justify-self: center;
}
</style>
